import { render, staticRenderFns } from "./SettingsFraud.vue?vue&type=template&id=5f6bfb45&"
import script from "./SettingsFraud.vue?vue&type=script&lang=js&"
export * from "./SettingsFraud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports